class Window {
  static scrollTo (args) {
    return window.scrollTo(args)
  }
}

export default Window
